import React, { useContext } from 'react'
import View from '../../atoms/View'
import Text from '../../atoms/TextNew'
import { t } from 'i18next'
import { BarType, ItemContext, ItemDispatchContext } from 'src/contexts/itemContext'

import RightArrowSvg from 'src/components/other/svg/RightArrowSvg'
import CloseXSvg from 'src/components/other/svg/CloseXSvg'
import { useNavigate } from 'react-router-dom'

interface Props {
  iconComponent: JSX.Element
  message: string
  color: 'bg-yellow' | 'bg-successGreen' | 'bg-darkBlue'
  barAfterClose: BarType
  redirectType?: 'redirect_realization' | 'redirect_my_bets' | 'no_redirect'
}

const ThankYouBar = ({ iconComponent, message, color, barAfterClose, redirectType }: Props): JSX.Element => {
  const dispatchItemContext = useContext(ItemDispatchContext)
  const itemContext = useContext(ItemContext)

  const navigate = useNavigate()
  if (dispatchItemContext === null || itemContext === null) {
    throw new Error('itemContext must be used within a UserProvider')
  }
  return (
    <View
      onClick={(e) => {
        e.stopPropagation()
      }}
      className={`h-[104px] relative px-10 flex gap-[120px] cursor-auto shadow-bothMedium rounded-b-4 ${color}`}>
      <View className="flex items-center">
        <Text className="text-xl text-white font-SemiBold">{iconComponent}</Text>
      </View>
      <View className="w-[350px] text-white relative top-2 text-xl flex justify-center items-center text-center font-SemiBold">
        {message}
      </View>
      <View className="flex flex-col justify-center">
        {redirectType === 'redirect_realization' && (
          <>
            <View
              data-testid="go-to-realization-button"
              className="flex relative top-1 gap-3 justify-center items-center text-white font-SemiBold cursor-pointer"
              onClick={() => {
                navigate('/purchasing/realization')
              }}>
              <>{t('buy_now_modal.realization')}</>
              <RightArrowSvg className="w-6 h-6 text-white" />
            </View>

            <Text className="text-white text-m relative top-4 max-w-[280px]">
              <>{t('buy_now_modal.go_to_realization')}</>
            </Text>
          </>
        )}
        {redirectType === 'redirect_my_bets' && (
          <>
            <View
              className="flex relative top-1 gap-3 justify-center items-center text-white font-SemiBold cursor-pointer"
              onClick={() => {
                navigate('/purchasing/my-bets')
              }}>
              <>{t('auction_contract_modal.go_to_bets')}</>
              <RightArrowSvg className="w-6 h-6 text-white" />
            </View>

            <Text className="text-white text-m relative top-4">
              <>{t('auction_contract_modal.go_to_bets_desc')}</>
            </Text>
          </>
        )}

        <View className="absolute right-4 top-4 text-white">
          <CloseXSvg
            className="w-8 h-8 cursor-pointer"
            onClick={() => {
              dispatchItemContext({ type: 'TOGGLE_VIEW' })
              dispatchItemContext({ type: 'SET_BAR', payload: barAfterClose })
            }}
          />
        </View>
      </View>
    </View>
  )
}
export default ThankYouBar
